var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcn24X24Criteria(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 0.75C7.28027 0.75 6.4541 1.38281 6.14062 2.25H0V3.75H6.14062C6.4541 4.61719 7.28027 5.25 8.25 5.25C9.21973 5.25 10.0459 4.61719 10.3594 3.75H18V2.25H10.3594C10.0459 1.38281 9.21973 0.75 8.25 0.75ZM8.25 2.25C8.67188 2.25 9 2.57812 9 3C9 3.42188 8.67188 3.75 8.25 3.75C7.82812 3.75 7.5 3.42188 7.5 3C7.5 2.57812 7.82812 2.25 8.25 2.25ZM13.5 6.75C12.5303 6.75 11.7041 7.38281 11.3906 8.25H0V9.75H11.3906C11.7041 10.6172 12.5303 11.25 13.5 11.25C14.4697 11.25 15.2959 10.6172 15.6094 9.75H18V8.25H15.6094C15.2959 7.38281 14.4697 6.75 13.5 6.75ZM13.5 8.25C13.9219 8.25 14.25 8.57812 14.25 9C14.25 9.42188 13.9219 9.75 13.5 9.75C13.0781 9.75 12.75 9.42188 12.75 9C12.75 8.57812 13.0781 8.25 13.5 8.25ZM5.25 12.75C4.28027 12.75 3.4541 13.3828 3.14062 14.25H0V15.75H3.14062C3.4541 16.6172 4.28027 17.25 5.25 17.25C6.21973 17.25 7.0459 16.6172 7.35938 15.75H18V14.25H7.35938C7.0459 13.3828 6.21973 12.75 5.25 12.75ZM5.25 14.25C5.67188 14.25 6 14.5781 6 15C6 15.4219 5.67188 15.75 5.25 15.75C4.82812 15.75 4.5 15.4219 4.5 15C4.5 14.5781 4.82812 14.25 5.25 14.25Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcn24X24Criteria);
export default __webpack_public_path__ + "static/media/icn_24x24_criteria.a372441756137ab5aba85d6aa85635bb.svg";
export { ForwardRef as ReactComponent };